import React, { useState, useEffect } from 'react';
import '../../styles/profileStyles/NewEmployee.css';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import { createNewEmployee, updateEmployee } from "../../services/API";

const NewEmployee = () => {
  const { state } = useLocation(); 
  const profileData = state?.profileData || {};
  const [activeTab, setActiveTab] = useState('Employees');
  const isUpdate = Boolean(state?.profileData); 
  
  const [formData, setFormData] = useState({
    id: profileData.ID || '',
    firstName: profileData.First_Name || '',
    lastName: profileData.Last_Name || '',
    address: profileData.Address || '',
    email: profileData.Email || '',
    birthday: profileData.Birth_Date || '',
    jobTitle: profileData.Job_Title ? [{ value: profileData.Job_Title, label: profileData.Job_Title }] : [],
    phoneNumber: profileData.Phone_Number || '',
    emergencyFirstName: profileData.Emergency_Contact_First_Name || '',
    emergencyLastName: profileData.Emergency_Contact_Last_Name || '',
    emergencyRelationship: profileData.Emergency_Contact_Relation || '',
    emergencyPhoneNumber: profileData.Emergency_Contact_Phone_Number || '',
    profileImage: profileData.Picture_File_Path || ''
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const existingData = localStorage.getItem('userData');
    if (!existingData) {
      fetch('/data/userData.json')
        .then(response => response.json())
        .then(data => localStorage.setItem('userData', JSON.stringify(data)))
        .catch(error => console.error('Error loading initial data:', error));
    }
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'My Profile') {navigate('/profilepage');}
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevData) => ({
          ...prevData,
          profileImage: reader.result,
          profileImageFile: file, // Keep the file for API submission
        }));
      };
      reader.readAsDataURL(file); // Convert the file to base64
    }
  };

  const triggerFileInput = () => {
    document.getElementById('imageUploadInput').click();
  };

  const handleSave = async () => {
    const { firstName, lastName, address, email, birthday, jobTitle, phoneNumber, emergencyFirstName, emergencyLastName, emergencyRelationship, emergencyPhoneNumber, profileImage } = formData;
  
    if (!firstName || !lastName || !address || !email || !birthday || !jobTitle || !phoneNumber || !emergencyFirstName || !emergencyLastName || !emergencyRelationship || !emergencyPhoneNumber) {
      setError('All fields except profile picture are mandatory.');
      console.error('Error: Missing required fields');
      return;
    } 
  
    try {
      if (isUpdate) {
        // Prepare the payload with only modified fields
        const updatedFields = new FormData();
        console.log("profile image ", profileImage);
        
        Object.keys(formData).forEach((key) => {
          if (formData[key] !== profileData[key]) {
            updatedFields[key] = formData[key];
          }
        });
                

        updatedFields.jobTitle = updatedFields.jobTitle[0]?.value || '';

        console.log("updatedFields.jobTitle", updatedFields.jobTitle);
        // Make the update API call
        const response = await updateEmployee(profileData.ID, updatedFields);
        
        console.log("Employee updated successfully:", response.data);
        
        navigate('/employeeslist');

      } else {
        // Prepare the payload for creation
        const payload = new FormData();
        payload.append("Email", email);
        payload.append("Password", "caliber2008");
        payload.append("First_Name", firstName);
        payload.append("Last_Name", lastName);
        payload.append("Phone_Number", phoneNumber);
        payload.append("Address", address);
        payload.append("Birth_Date", birthday);
        payload.append("Job_Title", jobTitle[0].value);
        payload.append("Emergency_Contact_First_Name", emergencyFirstName);
        payload.append("Emergency_Contact_Last_Name", emergencyLastName);
        payload.append("Emergency_Contact_Phone_Number", emergencyPhoneNumber);
        payload.append("Emergency_Contact_Relation", emergencyRelationship);
        if (formData.profileImageFile) {
          payload.append("profilePicture", formData.profileImageFile);
        }

        // Make the create API call
        const response = await createNewEmployee(payload, true);
        
        console.log("Employee created successfully:", response.data);
        
        navigate('/employeeslist'); // Navigate after successful creation
      }
  
      setError('');
    } catch (error) {
      console.error("Error saving employee:", error);
      setError(isUpdate ? 'Failed to update employee. Please try again.' : 'Failed to create employee. Please try again.');
    }
  };

  const handleCancel = () => {
    setFormData({
      firstName: '',
      lastName: '',
      address: '',
      email: '',
      birthday: '',
      jobTitle: '',
      phoneNumber: '',
      emergencyFirstName: '',
      emergencyLastName: '',
      emergencyRelationship: '',
      emergencyPhoneNumber: '',
      profileImage: ''
    });
    setError(''); // Clear any errors on cancel
    navigate('/employeeslist');
  };

  const jobTitleOptions = [
    { value: 'Employee', label: 'Employee' },
    { value: 'Admin', label: 'Admin' }
  ];

  const handleJobTitleChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      jobTitle: selectedOption ? [selectedOption] : []
    }));
  };

  return (
    <div className="new-employee-container">
      <Header />
      <div className="newemployee-content">
        <div className="newemployee-tabs-container">

          <h2 className="newemployee-tabs-title">{isUpdate ? 'Update Employee' : 'New Employee'}</h2>
          {/* <h2 className="newemployee-tabs-title">Profile</h2> */}

          <div className="newemployee-tabs">
            <button
              className={`newemployee-tab-item ${activeTab === 'My Profile' ? 'active' : ''}`}
              onClick={() => handleTabClick('My Profile')}
            >
              My Profile
            </button>
            <button
              className={`newemployee-tab-item ${activeTab === 'Employees' ? 'active' : ''}`}
              onClick={() => handleTabClick('Employees')}
            >
              Employees
            </button>
          </div>
        </div>
      </div>
      <div className="newemployeeScreen">
        
        <div className="newemployee-card">
          <div className="newemployee-image-container" onClick={triggerFileInput}>
            {formData.profileImage ? (
              <img 
                src={formData.profileImage} 
                className="newemployee-image" 
              />
            ) : (
              <p className="upload-placeholder">
                <img src="/images/uploadprofile.svg" alt="profile-icon" className="profile-logo"/><br/>
                Add Profile Picture
              </p>
            )}
            <input 
              id="imageUploadInput"
              type="file" 
              accept="image/*" 
              onChange={handleImageUpload} 
              className="image-upload-input"
            />
          </div>
          <div className="newemployee-name">Select Profile Picture here..</div>
        </div>
        <div className="newemployee-header">
          <h3 className="descript">Profile Description</h3>
          <div className="newemployee-details">
            <h3 className="prof-title">Profile Details</h3>
            <div className="newemployee-details-container">
              <table className="newemployee-table">
                <tbody>
                  <tr>
                    <td><strong>First Name</strong><br />
                      <input 
                        type="text" 
                        name="firstName" 
                        value={formData.firstName}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="First Name"
                      />
                    </td>
                    <td><strong>Last Name</strong><br />
                      <input 
                        type="text" 
                        name="lastName" 
                        value={formData.lastName}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Last Name"
                      />
                    </td>
                    <td><strong>Birthday</strong><br />
                      <input 
                        type="text" 
                        name="birthday" 
                        value={formData.birthday}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Birthday"
                      />
                    </td>
                    <td><strong>Job Title</strong><br />
                    <Select
                      className="custom-select-container"
                      isMulti={false}
                      options={jobTitleOptions}
                      value={formData.jobTitle}
                      onChange={handleJobTitleChange}
                      placeholder="Select Job Titles"
                    />
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Address</strong><br />
                      <input 
                        type="text" 
                        name="address" 
                        value={formData.address}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Address"
                      />
                    </td>
                    <td><strong>Email Address</strong><br />
                      <input 
                        type="email" 
                        name="email" 
                        value={formData.email}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Email"
                      />
                    </td>
                    <td><strong>Phone Number</strong><br />
                      <input 
                        type="text" 
                        name="phoneNumber" 
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Phone Number"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="newemployee-emergency-contact">
            <h3 className="newemployee-contact-title">Emergency Contact Details</h3>
            <div className="newemployee-contact-details">
              <table className="newemployee-emergencycontact">
                <tbody>
                  <tr>
                    <td><b>First Name</b><br />
                      <input 
                        type="text" 
                        name="emergencyFirstName" 
                        value={formData.emergencyFirstName}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Emergency First Name"
                      />
                    </td>
                    <td><b>Last Name</b><br />
                      <input 
                        type="text" 
                        name="emergencyLastName" 
                        value={formData.emergencyLastName}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Emergency Last Name"
                      />
                    </td>
                    <td><b>Relationship</b><br />
                      <input 
                        type="text" 
                        name="emergencyRelationship" 
                        value={formData.emergencyRelationship}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Relationship"
                      />
                    </td>
                    <td><b>Phone Number</b><br />
                      <input 
                        type="text" 
                        name="emergencyPhoneNumber" 
                        value={formData.emergencyPhoneNumber}
                        onChange={handleInputChange}
                        className="newemployee-input"
                        placeholder="Emergency Phone Number"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {error && <p className="error-message">{error}</p>}

      <div className="button-container">
        <button className="cancel-button" onClick={handleCancel}>Cancel</button>
        <button className="save-button" onClick={handleSave}>
          {isUpdate ? 'Update' : 'Save'}
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default NewEmployee;